/**
 * @todo Transform Basket into a collection
 *
 * Reserved options:
 * {
 *   action: Allow switch within buildURL
 *   dataType: @see
 * }
 *
 * Model reserved properties:
 * {
 *   state: Flatten the fetch/add/update/delete logic of the model > view
 *   html: Html to be injected into the view
 * }
 */
import Base from "./Base";
import _ from "underscore";
import {secureURL} from "../others/Configuration";

export default Base.extend({

        initialize: function () {
          this.setFromAPI = this.setFromAPI.bind(this);
          this.setErrorFromAPI = this.setErrorFromAPI.bind(this);
          this.getEnvironment = this.getEnvironment.bind(this);

            this.url = _.compact([secureURL, "/basket"]).join("");
        },

        buildURL: function (options) {
            switch (options.action) {
                case "add":
                    return _.compact([this.url, "/add"]).join("");

                case "remove":
                    return _.compact([this.url, "/delete"]).join("");

                case "update":
                    return _.compact([this.url, "/update"]).join("");
            }
        },

        /**
         * @todo Refactor common propeties
         */
        getEnvironment: function (options) {
            var payload = [];

            switch (options.action) {
                case "add":
                    payload.push({
                        "ProductId": this.get("productId"),
                        "Offer": this.get("offerId"),
                        "MasterProductId": this.get("masterProductId")
                    });
                    break;

                case "remove":
                    payload.push({
                        "ProductId": this.get("productId"),
                        "Offer": this.get("offerId"),
                        "MasterProductId": this.get("masterProductId")
                    });
                    break;

                case "update":
                    /*var products = this.get("products"), index, indexMax = products.length;
                    for (index = 0; index < indexMax; index++) {
                      this.payload.push({
                        "ProductId": products[index].productId,
                        "Offer": products[index].offerId,
                        "MasterProductId": products[index].masterProductId,
                        "Quantity": products[index].quantityDifference
                      });
                    }*/
                    payload.push({
                        "ProductId": this.get("productId"),
                        "Offer": this.get("offerId"),
                        "MasterProductId": this.get("masterProductId"),
                        "Quantity": this.get("quantityDifference")
                    });
                    break;
            }

            return payload;
        },

        setFromAPI: function (response, options) {
            switch (options.action) {
                case "add":
                    this.set({
                        "state": "added",
                        "html": response
                    });
                    break;

                case "remove":
                    this.set({
                        "state": "removed",
                        "html": response
                    });
                    break;

                case "update":
                    this.set({
                        "state": "updated",
                        "html": response
                    });
                    break;
            }
        },

        setErrorFromAPI: function (responseError, options) {
            console.error(responseError);
        }
    });
